import { ENVIRONMENT_STAMP } from '../../utils/env';
import ToggleThemeButton from '../buttons/ToggleThemeButton/ThemeToggleButton';
import UserProfileButton from '../buttons/UserProfileButton';
import ApplicationName from './ApplicationName';
import styles from './Header.module.scss';
import { ReportsLink } from '../links/ReportsLink/ReportsLink';
import KunskapLink from '../links/KunskapLink/KunskapsLink';
import ExportButton from '../buttons/ExportButton';

import MarketSelectorButton from '../buttons/MarketSelectorButton';
import { SkipToMain } from './SkipToMain';
import { FilterLink } from '../links/FilterLink/FilterLink';

const style = ENVIRONMENT_STAMP
  ? { backgroundColor: 'rgb(var(--color-environment-stamp))' }
  : undefined;

const Header = () => {
  return (
    <div className={styles.headerComponent} style={style}>
      <SkipToMain />
      <ApplicationName />
      <div className={styles.group}>
        <FilterLink />
        <ReportsLink />
        <KunskapLink />
        <ExportButton />
        <MarketSelectorButton />
        <UserProfileButton />
        <ToggleThemeButton />
      </div>
    </div>
  );
};

export default Header;
